<template>
  <transition name="modal">
    <div class="modal-mask" @click="closeModal($event)">
      <div class="modal-wrapper" id="wrapper">
        <div class="modal-container">
          <div class="option-container">
            <h5>
              You have chosen to abstain on all matters.
            </h5>

            <p>
              The proxyholder is not authorized to vote on your behalf with
              respect to any matter at the meeting. Your proxy will only count
              towards quorum.
            </p>

            <br />

            <button-component
              color="primary"
              value="Confirm"
              log-action="review-modal"
              @click-review-modal="trackClick"
            />
            <br />
            <button class="mdl-button mdl-js-button" @click="closeModalButton">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ButtonComponent from '@/components/Button.vue';

export default {
  components: {
    ButtonComponent
  },
  props: {},
  mounted() {
    componentHandler.upgradeAllRegistered();
  },
  methods: {
    // close modal if background is clicked
    closeModal(event) {
      if (event.target.id === 'wrapper') {
        this.$emit('close-modal');
      }
    },
    // Handle modal button closing
    closeModalButton() {
      this.$emit('close-modal');
    },
    trackClick() {
      this.$emit('accept-review-modal');
    }
  },
  data() {
    return {
      path: this.$route.path.split('?')[0]
    };
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 75vw;
  max-height: 80vh;
  margin: 0px auto;
  padding: 5%;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
}
.modal-buttons {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
/* Transitions */
.modal-enter,
.modal-leave {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.option-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Review/ReviewModal.vue